import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { ModalComponent } from '../modal/modal.component';


type ControlType = 'text' | 'email' | 'number' | 'tel' | 'password' | 'select' | 'textarea' | 'checkbox' | 'file' | 'selectOnboarding' | 'selectOnboardingSize';
type Autocomplete = 'on' | 'off' | 'new-password';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  host: { class: 'app-input' }
})
export class InputComponent implements ControlValueAccessor, OnInit, OnChanges {

  @ViewChild('element') element: ElementRef;

  @Input('type') type:ControlType
  @Input('label') label:string
  @Input('initialValue') value:any
  @Input('required') required:boolean
  @Input('requiredUsuario') requiredUsuario:boolean
  @Input('selectOptions') options:any[] = []
  @Input('selectOptionsKey') optionsKey:string
  @Input('selectOptionsName') optionsName:string
  @Input('disabledTextValue') disabledTextValue:string
  @Input('terms') terms:boolean
  @Input('readonly') readonly:boolean
  @Input('step') step:number
  @Input('no-margins') noMargins:boolean
  @Input('accept') accept:string
  @Input('mime-types') mimeTypes:string
  @Input() autocomplete: Autocomplete = 'off';
  @Input() placeholder = '';
  @Input('pattern') pattern:boolean
  @Input('number') number:boolean
  @ViewChild('modalCertificado') modalCertificado:ModalComponent
  @Input() fileInput: boolean = false;
  @Input() vmaxlength: boolean = false;
  @Input() enviarEmail: string;
  @Input() existeDoc: boolean = false;
  @Input('disabledSelect') disabledSelect:boolean

  @Output()
  change: EventEmitter<any> = new EventEmitter()
  @Output()
  keyup: EventEmitter<any> = new EventEmitter()
  @Output()
  close: EventEmitter<any> = new EventEmitter()
  @Output()
  next: EventEmitter<any> = new EventEmitter()
  @Output()
  name: EventEmitter<any> = new EventEmitter()
  @Output()
  format: EventEmitter<any> = new EventEmitter()

  modalClose: boolean=false;
  modalPinSession: boolean=false;
  correoValidacion: any;
  correoError: boolean = false;
  fileCert: string;
  dropFile: boolean = false;
  vMax: number;
  contactEmail: string;

  constructor(
    @Self()
    @Optional()
    public ngControl: NgControl) {
      if (this.ngControl) { this.ngControl.valueAccessor = this }
  }

  onChangeCallback: any = () => {}
  onTouchedCallback: any = () => {}

  writeValue(value:any) {
    // if (this.type==='select') console.log('wv', value)
    this.value = value?.target ? value.target.value : value
    this.onChangeCallback(value)
  }
  registerOnChange(fn: (_: any) => void): void {
    this.onChangeCallback = fn
  }
  registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn
  }
  disabled:boolean
  setDisabledState(disabled:boolean) {
    this.disabled = disabled
  }

  selectTextValue:string
  ngOnInit(): void {
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if(changes.fileInput != null) {
      //console.log(changes.fileInput.currentValue);
      if(changes.fileInput.currentValue == true) {
        this.editNameCertificado = false;
        this.file = null;
        //console.log('ngOnChanges');
      }
    }

    if(changes.vmaxlength != null) {
      //onsole.log(changes.vmaxlength.currentValue);
      if(changes.vmaxlength.currentValue == true) {
        if (this.type === 'number') {
          this.vMax = 9;
        } else {
          this.vMax = 12;
        }
        //console.log('ngOnChanges');
      }
    }

    if(changes.enviarEmail != null) {
      //console.log(changes.enviarEmail.currentValue);
      this.contactEmail = changes.enviarEmail.currentValue;
      this.checkCorreo(this.contactEmail);
    }
  }

  handleChange(e) {
    let val:any
    if (this.type === 'checkbox') val = e.target.checked
    else val = e.target.value

    if(this.vMax == 12) {
      let stringEspacios = val;
      val = stringEspacios.trim();
      //console.log(val, 'valorInput');
    }

    this.writeValue(val)
    this.change.emit(val)

    if (this.type === 'email') {
      this.checkCorreo(val);
    }
  }

  formatError:boolean
  file:any
  nameCertificado:any
  handleFileChange(e) {
    this.formatError = false
    console.log(this.formatError,'handleFileChange error')
    if (!this.dropFile) {
      this.fileCert = e.target.files[0];
    } else {
      this.fileCert = e.dataTransfer.files[0];
    }
    let val:any = this.fileCert
    if (this.mimeTypes) {
      let valid:boolean = true
      const types:string[] = this.mimeTypes.split(',')
      types.forEach((t:string) => t = t.trim())
      valid = types.includes(val.type)

      if (!valid) {
        this.formatError = true
        this.format.emit(this.formatError);
        console.log(this.formatError,'error true')
        return
      }
    }

    this.file = val
    this.nameCertificado = this.file.name.slice(0,-4)
    this.writeValue(val)
    this.change.emit(val)
    this.format.emit(this.formatError);
    console.log(this.formatError, 'error false')
    this.dropFile = false;
  }

  editNameCertificado:boolean = false
  editName(){
    this.editNameCertificado = true
  }
  
  allowDrop(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  drop(e) {
    e.preventDefault();
    this.dropFile = true;
    this.handleFileChange(e);
  }
  
  fileInputClick() {
    this.dropFile = false;
    if(this.file==null) {
      this.element.nativeElement.click()
    }
  }

  onInput(event): void {
    const value = event.target.value;
    this.writeValue(value);
    this.change.emit(value);
  }

  closeModalCertificado() {
    this.modalClose = true;
    this.close.emit(this.modalClose);
  }

  nameModificado:string
  abrilModalPinSession() {
    this.modalPinSession = true;
    this.nameModificado = this.editNameCertificado ? document.getElementById("nameModificado").innerHTML : this.nameCertificado;
    this.name.emit(this.nameModificado);
    this.next.emit(this.modalPinSession);
  }

  message1:string;
  receiveMessage($event) {
    this.message1 = $event
    console.log( this.message1,'message')
  }

  checkCorreo(val) {
    this.correoValidacion = val;
    //console.log(this.correoValidacion)
    const regexEmail = /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}),?\s*){1,5}$/;
    let validacion = regexEmail.test(this.correoValidacion)
      //console.log(validacion)
    
    if (!validacion) {
      this.correoError = true
    } else {
      this.correoError = false
    }
    
    //console.log(this.correoError, 'correoError')
  }

}
